import { render, staticRenderFns } from "./addEditJobType.vue?vue&type=template&id=025bd458&scoped=true&"
import script from "./addEditJobType.vue?vue&type=script&lang=js&"
export * from "./addEditJobType.vue?vue&type=script&lang=js&"
import style0 from "./addEditJobType.vue?vue&type=style&index=0&id=025bd458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bd458",
  null
  
)

export default component.exports